import { FormatCriteria, BasicScenario, FormatWrapper } from '@wizeoo/akm-message-lib';

import { WizCommand } from '@wizeoo/akm-component-lib';
import { WIZ_COMMAND_METHOD} from '@wizeoo/akm-core-lib';
import { ExternalAPI } from '../../model/external-api';
import { Model } from '../../model/model';

/**
 * Commande REST de recherche des formats de mesures
 */
export class FindFormatCommand extends WizCommand<FormatWrapper> {

  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  }


  /** retourne un wrapper pre-alimenté */
  public formatWrapper(): FormatWrapper {
    const wrapper: FormatWrapper = new FormatWrapper();
    wrapper.method = WIZ_COMMAND_METHOD.FIND;
    wrapper.scenario = new BasicScenario();
    wrapper.scenario.languageCode = this.model.currentLocaleCode;
    wrapper.criteria = new FormatCriteria();
    return wrapper;
  }

  /** configuration du chargement des formats à partir d'un domaine et d'une bu */
  public find(domain: string, bu: string): FindFormatCommand {
    const wrapper: FormatWrapper = this.formatWrapper();
    wrapper.criteria.domain = domain;
    wrapper.criteria.businessUnitCode = bu;
    this.configureRemote(ExternalAPI.FORMAT_API, wrapper);
    return this;
  }

  wizResult() {
    super.wizResult();
    if (this.result?.entities) {
      this.model.formatEngine.feedFormats(this.result.entities);
    }

  }
}
